<template>
  <div 
    v-if="slug !== null && slug !== 'error' && pageData"
    class="ThemaBeknopt">

    <HeaderSection 
      :title="`Thema: ${title}`"
      :closeLinkTo="{ name: 'list-themas' }">
      <p>
        {{ definition }}
      </p>
    </HeaderSection>

    <ContentSection>
      <SectionHeader label="Verhalen" />
      
      <p v-if="items.length === 0">
        Er zijn nog geen verhalen verbonden aan dit thema. <br />
        Heb jij een goed verhaal om te delen? <br />
        <Link :to="{ name: 'page-aanmaken' }" label="Laat het ons weten!" arrow />
      </p>
    </ContentSection>
    <List 
      :items="items" 
      :sortingBy="sortingBy" 
      type="project"
      readmore="zoom" />
    
    <!-- <ContentSection>
      <SectionHeader label="Gemeenten" />
      <p>TODO</p>
    </ContentSection> -->
    

  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';
import SectionHeader from '@/components/section/Header';
import ContentSection from '@/components/section/ContentSection';
import Link from '@/components/Link';

export default {
  name: 'ThemaBeknopt',
  components: {
    List,
    HeaderSection,
    SectionHeader,
    ContentSection,
    Link
  },
  data() {
    return {
      thema: 'kostenneutraal',
      slug: null,
      sortingBy: [
        {
          key: 'name',
          label : 'A-Z'
        }
      ]
    }
  },
  computed: {
    pageData() {
      return this.$store.getters.getThemaBySlug({
        slug: this.slug
      });
    },
    title() {
      return this.pageData.name;
    },
    definition() {
      return this.pageData.summary;
    },
    items() {
      let items = this.$store.getters.getProjectsByThema({id: this.pageData.id});
      items.forEach((item) => {
        item.to = { name: 'project-beknopt', params: { slug: item.slug } };
        return item;
      });
      return items;
    }
  },
  created() {
    this.slug = this.$route.params.slug 
      ? this.$route.params.slug 
      : 'error';
  }
}
</script>

<style lang="scss">
  .ThemaBeknopt {
    position: relative;
    display: flex;
    flex-direction: column;

    .ContentSection {
      margin-bottom: 0;
      .SectionHeader {
        margin-bottom: 0;
      }
    }
    .List__items {
      padding-top: 16px !important;
    }
  }
</style>
